
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2342',
  depVersions: {
  "customer-portal-app": "static-1.2342",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.466",
  "data-fetching-client": "static-1.9679",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25418",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5602",
  "hs-test-utils": "static-1.8024",
  "hub-http": "static-1.6232",
  "hub-http-shared-msw-handlers": "static-1.9991",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18268",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11482",
  "I18n": "static-7.1628",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6475",
  "payment-link-components": "static-1.23577",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7047",
  "quartz-core": "static-1.6266",
  "react": "static-7.186",
  "react-colorpicker": "static-2.10217",
  "react-dlb": "static-1.79",
  "react-utils": "static-2.5351",
  "rich-text-lib": "static-1.19855",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18010",
  "ui-components-test-utils": "static-1.5619",
  "UIComponents": "static-3.8428",
  "foundations-assets": "static-1.4877",
  "foundations-components": "static-1.7960",
  "foundations-theming": "static-1.4429",
  "foundations-theming-specialty": "static-1.2145",
  "framer-motion": "static-1.72",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.909",
  "quartz-config": "static-1.825",
  "quartz-routing": "static-1.477",
  "quick-fetch": "static-1.3923",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16682",
  "rpc-client-utils": "static-1.4663",
  "sanitize-text": "static-1.8152",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.55",
  "ui-addon-draggable": "static-3.4773",
  "ui-addon-react-router-dom": "static-1.9552",
  "usage-tracker": "static-1.7354",
  "usage-tracker-anonymous": "static-1.5771",
  "usage-tracker-core": "static-1.7204",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3405",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3324",
  "quartz-webpack": "static-1.3271",
  "bend-plugin-quartz-routing": "static-1.125",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.82",
  "customer-data-objects": "static-1.7680",
  "frontend-preferences-client": "static-1.7938",
  "laboratory-lib": "static-3.7166",
  "onboarding-scopes": "static-1.6472",
  "seat-types-lib": "static-1.39",
  "ui-addon-opt": "static-4.8377",
  "HeadJS": "static-2.762",
  "hs-test-utils-bend-plugin": "static-1.3135",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.87",
  "ts-schema": "static-1.4086",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7769",
  "cssUtils": "static-1.794",
  "customer-data-ui-utilities": "static-1.9837",
  "HubStyle": "static-2.11789",
  "knowledge-content-types": "static-1.8483",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.722",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.487",
  "ui-addon-emoji-picker": "static-1.9898",
  "ui-addon-i18n": "static-1.11159",
  "ui-business-units-lib": "static-1.9065",
  "ui-shepherd-react": "static-3.10175",
  "video-components-external": "static-1.11315",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4338",
  "commerce-tours-lib": "static-1.6122",
  "customer-data-properties": "static-1.51592",
  "getting-started-shared-tasks": "static-1.18501",
  "growth-onboarding-reliability": "static-1.5093",
  "onboarding-tours": "static-1.16633",
  "reference-resolvers-lite": "static-1.8105",
  "sales-checkout-service-client": "static-1.3651",
  "ui-addon-iframeable": "static-1.9068",
  "user-context": "static-1.5116",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.836",
  "hubspotter-http": "static-1.4658",
  "icons": "static-2.648",
  "mobile-manifest-mixins": "static-1.536",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.722",
  "quartz-head": "static-1.712",
  "quartz-test": "static-1.722",
  "quartz-tracking": "static-1.426",
  "ui-fonts": "static-1.744",
  "usage-tracker-container": "static-1.7344",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9435",
  "data-token-picker": "static-1.16429",
  "FileManagerLib": "static-1.39299",
  "property-translator": "static-1.5411",
  "atom": "static-1.5083",
  "merchandise-lib": "static-1.264",
  "purchase-motions-components": "static-1.5924",
  "salesImages": "static-1.525",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5443",
  "react-select-plus": "static-1.105",
  "react-virtualized": "static-2.99",
  "ui-images": "static-2.1156",
  "bend-plugin-foundations-components": "static-1.4229",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.26",
  "trellis-assets": "static-1.1978",
  "bend-plugin-foundations-theming": "static-1.2912",
  "foundations-theming-base": "static-1.3414",
  "stylex": "static-1.33",
  "interframe": "static-3.4770",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5768",
  "web-vitals": "static-1.6",
  "bend-plugin-chirp-manifest": "static-1.73",
  "chirp-fetch": "static-1.1898",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4487",
  "react-flip-move": "static-1.70",
  "bender-build-tools": "static-1.3205",
  "inbound-db-properties-service-client": "static-1.3852",
  "superstore": "static-1.4772",
  "feedback-loader": "static-1.29315",
  "ai-components-ui-library": "static-1.9013",
  "ui-addon-video-player": "static-1.8713",
  "ui-coaching-tips": "static-1.28596",
  "sassPrefix": "static-1.156",
  "react-dnd-compat": "static-1.4625",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2507",
  "magpie-lib": "static-1.5558",
  "navigation-messaging": "static-1.7399",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8181",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4662",
  "content-media-composition-data-lib": "static-1.12359",
  "content-media-compositions": "static-2.16366",
  "idb-keyval": "static-1.44",
  "immer": "static-1.33",
  "immerable": "static-1.4165",
  "magpie-types": "static-1.5018",
  "media-bridge-lib": "static-1.18948",
  "video-data-lib": "static-1.34973",
  "commerce-products-lib": "static-1.9611",
  "crm-message-bus": "static-1.43029",
  "growth-data-modal": "static-1.5446",
  "hubspot-apollo-client": "static-1.4890",
  "onboarding-tours-client": "static-1.4847",
  "calling-global-api": "static-1.64552",
  "calling-internal-common": "static-1.31313",
  "calling-lifecycle-internal": "static-1.65934",
  "calling-lifecycle-messages": "static-1.58228",
  "conditional-properties-service-client": "static-1.3803",
  "crm-links": "static-1.6304",
  "customer-data-objects-ui-components": "static-1.13038",
  "customer-data-properties-shared-msw-handlers": "static-1.9318",
  "customer-data-property-utils": "static-1.8101",
  "external-options-client-types": "static-1.4165",
  "file-manager-components": "static-1.23659",
  "framework-data-schema-resolvers": "static-1.6895",
  "google-libphonenumber": "static-1.38",
  "hs-resources": "static-1.162",
  "inbound-db-meta-service-client": "static-1.3592",
  "inbounddb-objects-service-types": "static-1.4229",
  "meetings-icalendar-utils-lib": "static-1.642",
  "multi-currency-client-types": "static-1.3697",
  "object-builder-ui-client": "static-1.48788",
  "pipeline-validation-client-types": "static-1.3971",
  "property-value-citations": "static-1.2207",
  "pulse": "static-1.585",
  "smart-property-lib": "static-1.7131",
  "tiered-pricing": "static-1.1243",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11000",
  "growth-onboarding-confetti": "static-1.3077",
  "growth-onboarding-next-action-utils": "static-1.1958",
  "navigation-components": "static-1.18072",
  "onboarding-tours-utils": "static-1.699",
  "ui-shepherd-tracker": "static-1.7556",
  "ui-universal-auth": "static-1.8991",
  "batch-promise": "static-1.1552",
  "getting-started-shared-tasks-store": "static-1.17619",
  "hubspotter-http-shared-msw-handlers": "static-1.9989",
  "usage-tracker-session-replay": "static-1.5040",
  "audio-components": "static-1.5931",
  "FileManagerCore": "static-1.39158",
  "FileManagerImages": "static-1.36810",
  "video-components": "static-1.13318",
  "foundations-components-legacy": "static-1.985",
  "purchase-motions-api": "static-1.5927",
  "signup-constants": "static-1.18858",
  "signup-ui-url-generator": "static-2.8060",
  "trials-service-types": "static-1.3913",
  "usage-tracker-public": "static-1.7165",
  "chatspot-core": "static-1.21389",
  "ContentUtils": "static-1.68403",
  "copilot-toolkit": "static-1.11166",
  "growth-onboarding-feedback-components": "static-1.6591",
  "reactive-lib": "static-1.735",
  "simple-logging-lib": "static-1.3061",
  "commerce-permissions": "static-1.780",
  "customer-data-tracking": "static-1.6900",
  "products-iframe-lib": "static-1.7972",
  "products-ui-components-shared-msw-handlers": "static-1.10373",
  "restore-request-side-panel-lib": "static-1.914",
  "onboarding-data-sync-lib": "static-1.1975",
  "hubspot-apollo-cache": "static-1.349",
  "calling-error-reporting": "static-1.31320",
  "shared-worker-versioning": "static-1.11047",
  "calling-usage-tracker": "static-1.6552",
  "self-service-api": "static-1.10258",
  "voice-sms-access-library": "static-1.1016",
  "conversations-skeleton-state": "static-1.7257",
  "location-customization-utils-lib": "static-1.9301",
  "crm-pipelines-api-client-types": "static-1.4145",
  "fdsr-migration-layer": "static-1.14",
  "framework-builder-read-service-client": "static-1.4011",
  "framework-data-schema-quick-fetch": "static-1.6800",
  "persist-promise": "static-1.3709",
  "bend-plugin-pulse": "static-1.88",
  "directed-graph": "static-1.946",
  "event-emitter": "static-1.958",
  "fast-json-patch": "static-1.63",
  "data-agent-kit": "static-1.211",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10074",
  "fsm": "static-1.3741",
  "policy-lib": "static-1.6788",
  "react-tinymce": "static-1.55279",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10137",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54405",
  "tinymce-plugins": "static-1.57519",
  "tinymce-themes": "static-1.56375",
  "growth-onboarding-next-action-components": "static-1.1986",
  "user-context-client": "static-1.4623",
  "nest": "static-1.237",
  "unified-auth-core-lib": "static-1.787",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4547",
  "video-embed": "static-1.35807",
  "content-icons-ui": "static-1.2229",
  "social-insights-client-types": "static-1.22151",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4823",
  "integrations-lib": "static-1.16185",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4269",
  "InboxConnectUtils": "static-4.14849",
  "meetings-connect-utils-lib": "static-1.7616",
  "calling-orchestration-schema": "static-1.35793",
  "crm-record-cards-service-types": "static-1.3603",
  "highcharts": "static-8.104",
  "trellis-story-utils": "static-1.4526",
  "storybook-react": "static-1.33",
  "hub-http-contrib": "static-1.3053",
  "tinymce-data": "static-1.40490",
  "ui-addon-sales-email": "static-1.5221",
  "codemirror": "static-5.95",
  "layout-dnd-components": "static-1.12468",
  "layout-dnd-utils": "static-1.11443",
  "react-codemirror": "static-1.10637",
  "ui-brand-identity-lib": "static-1.15322",
  "NamespacedHubStyle": "static-2.9065",
  "outpost": "static-1.4192",
  "flux-actions": "static-1.338",
  "integrations-error-boundary-lib": "static-1.13600",
  "integrations-tracking-lib": "static-1.5611",
  "native-integrations-shared-strings": "static-1.7792",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10376",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.505",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68478",
  "layout-data-lib": "static-1.9768",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.3023",
  "google-sheets-integration-lib": "static-1.277",
  "microsoft-drive-integration-lib": "static-1.395",
  "slack-ui-library": "static-1.10403",
  "advanced-menus-core": "static-1.15145",
  "advanced-menus-lib": "static-1.12084",
  "ExportDialog": "static-6.10399",
  "ui-memberships-settings-lib": "static-1.34082",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15144",
  "simple-menus-lib": "static-1.16661"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2342",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.466",
  "data-fetching-client": "/data-fetching-client/static-1.9679",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25418",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5602",
  "hs-test-utils": "/hs-test-utils/static-1.8024",
  "hub-http": "/hub-http/static-1.6232",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9991",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18268",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11482",
  "I18n": "/I18n/static-7.1628",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6475",
  "payment-link-components": "/payment-link-components/static-1.23577",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7047",
  "quartz-core": "/quartz-core/static-1.6266",
  "react": "/react/static-7.186",
  "react-colorpicker": "/react-colorpicker/static-2.10217",
  "react-dlb": "/react-dlb/static-1.79",
  "react-utils": "/react-utils/static-2.5351",
  "rich-text-lib": "/rich-text-lib/static-1.19855",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18010",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5619",
  "UIComponents": "/UIComponents/static-3.8428",
  "foundations-assets": "/foundations-assets/static-1.4877",
  "foundations-components": "/foundations-components/static-1.7960",
  "foundations-theming": "/foundations-theming/static-1.4429",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2145",
  "framer-motion": "/framer-motion/static-1.72",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.909",
  "quartz-config": "/quartz-config/static-1.825",
  "quartz-routing": "/quartz-routing/static-1.477",
  "quick-fetch": "/quick-fetch/static-1.3923",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16682",
  "rpc-client-utils": "/rpc-client-utils/static-1.4663",
  "sanitize-text": "/sanitize-text/static-1.8152",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.55",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4773",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9552",
  "usage-tracker": "/usage-tracker/static-1.7354",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5771",
  "usage-tracker-core": "/usage-tracker-core/static-1.7204",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3405",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3324",
  "quartz-webpack": "/quartz-webpack/static-1.3271",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.125",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.82",
  "customer-data-objects": "/customer-data-objects/static-1.7680",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7938",
  "laboratory-lib": "/laboratory-lib/static-3.7166",
  "onboarding-scopes": "/onboarding-scopes/static-1.6472",
  "seat-types-lib": "/seat-types-lib/static-1.39",
  "ui-addon-opt": "/ui-addon-opt/static-4.8377",
  "HeadJS": "/HeadJS/static-2.762",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3135",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.87",
  "ts-schema": "/ts-schema/static-1.4086",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7769",
  "cssUtils": "/cssUtils/static-1.794",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9837",
  "HubStyle": "/HubStyle/static-2.11789",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.722",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9898",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11159",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9065",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10175",
  "video-components-external": "/video-components-external/static-1.11315",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4338",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6122",
  "customer-data-properties": "/customer-data-properties/static-1.51592",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18501",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5093",
  "onboarding-tours": "/onboarding-tours/static-1.16633",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8105",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3651",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9068",
  "user-context": "/user-context/static-1.5116",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.836",
  "hubspotter-http": "/hubspotter-http/static-1.4658",
  "icons": "/icons/static-2.648",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.536",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.722",
  "quartz-head": "/quartz-head/static-1.712",
  "quartz-test": "/quartz-test/static-1.722",
  "quartz-tracking": "/quartz-tracking/static-1.426",
  "ui-fonts": "/ui-fonts/static-1.744",
  "usage-tracker-container": "/usage-tracker-container/static-1.7344",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9435",
  "data-token-picker": "/data-token-picker/static-1.16429",
  "FileManagerLib": "/FileManagerLib/static-1.39299",
  "property-translator": "/property-translator/static-1.5411",
  "atom": "/atom/static-1.5083",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "purchase-motions-components": "/purchase-motions-components/static-1.5924",
  "salesImages": "/salesImages/static-1.525",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5443",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-virtualized": "/react-virtualized/static-2.99",
  "ui-images": "/ui-images/static-2.1156",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4229",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.26",
  "trellis-assets": "/trellis-assets/static-1.1978",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2912",
  "foundations-theming-base": "/foundations-theming-base/static-1.3414",
  "stylex": "/stylex/static-1.33",
  "interframe": "/interframe/static-3.4770",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5768",
  "web-vitals": "/web-vitals/static-1.6",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.73",
  "chirp-fetch": "/chirp-fetch/static-1.1898",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4487",
  "react-flip-move": "/react-flip-move/static-1.70",
  "bender-build-tools": "/bender-build-tools/static-1.3205",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3852",
  "superstore": "/superstore/static-1.4772",
  "feedback-loader": "/feedback-loader/static-1.29315",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9013",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8713",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28596",
  "sassPrefix": "/sassPrefix/static-1.156",
  "react-dnd-compat": "/react-dnd-compat/static-1.4625",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2507",
  "magpie-lib": "/magpie-lib/static-1.5558",
  "navigation-messaging": "/navigation-messaging/static-1.7399",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8181",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4662",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12359",
  "content-media-compositions": "/content-media-compositions/static-2.16366",
  "idb-keyval": "/idb-keyval/static-1.44",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4165",
  "magpie-types": "/magpie-types/static-1.5018",
  "media-bridge-lib": "/media-bridge-lib/static-1.18948",
  "video-data-lib": "/video-data-lib/static-1.34973",
  "commerce-products-lib": "/commerce-products-lib/static-1.9611",
  "crm-message-bus": "/crm-message-bus/static-1.43029",
  "growth-data-modal": "/growth-data-modal/static-1.5446",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4890",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4847",
  "calling-global-api": "/calling-global-api/static-1.64552",
  "calling-internal-common": "/calling-internal-common/static-1.31313",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65934",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58228",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3803",
  "crm-links": "/crm-links/static-1.6304",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13038",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9318",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8101",
  "external-options-client-types": "/external-options-client-types/static-1.4165",
  "file-manager-components": "/file-manager-components/static-1.23659",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6895",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "hs-resources": "/hs-resources/static-1.162",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3592",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4229",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.642",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3697",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48788",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3971",
  "property-value-citations": "/property-value-citations/static-1.2207",
  "pulse": "/pulse/static-1.585",
  "smart-property-lib": "/smart-property-lib/static-1.7131",
  "tiered-pricing": "/tiered-pricing/static-1.1243",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11000",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3077",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1958",
  "navigation-components": "/navigation-components/static-1.18072",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.699",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7556",
  "ui-universal-auth": "/ui-universal-auth/static-1.8991",
  "batch-promise": "/batch-promise/static-1.1552",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17619",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9989",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5040",
  "audio-components": "/audio-components/static-1.5931",
  "FileManagerCore": "/FileManagerCore/static-1.39158",
  "FileManagerImages": "/FileManagerImages/static-1.36810",
  "video-components": "/video-components/static-1.13318",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.985",
  "purchase-motions-api": "/purchase-motions-api/static-1.5927",
  "signup-constants": "/signup-constants/static-1.18858",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8060",
  "trials-service-types": "/trials-service-types/static-1.3913",
  "usage-tracker-public": "/usage-tracker-public/static-1.7165",
  "chatspot-core": "/chatspot-core/static-1.21389",
  "ContentUtils": "/ContentUtils/static-1.68403",
  "copilot-toolkit": "/copilot-toolkit/static-1.11166",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6591",
  "reactive-lib": "/reactive-lib/static-1.735",
  "simple-logging-lib": "/simple-logging-lib/static-1.3061",
  "commerce-permissions": "/commerce-permissions/static-1.780",
  "customer-data-tracking": "/customer-data-tracking/static-1.6900",
  "products-iframe-lib": "/products-iframe-lib/static-1.7972",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10373",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.914",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1975",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.349",
  "calling-error-reporting": "/calling-error-reporting/static-1.31320",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11047",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6552",
  "self-service-api": "/self-service-api/static-1.10258",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1016",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7257",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9301",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4145",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.14",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4011",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6800",
  "persist-promise": "/persist-promise/static-1.3709",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.88",
  "directed-graph": "/directed-graph/static-1.946",
  "event-emitter": "/event-emitter/static-1.958",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "data-agent-kit": "/data-agent-kit/static-1.211",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10074",
  "fsm": "/fsm/static-1.3741",
  "policy-lib": "/policy-lib/static-1.6788",
  "react-tinymce": "/react-tinymce/static-1.55279",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10137",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54405",
  "tinymce-plugins": "/tinymce-plugins/static-1.57519",
  "tinymce-themes": "/tinymce-themes/static-1.56375",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1986",
  "user-context-client": "/user-context-client/static-1.4623",
  "nest": "/nest/static-1.237",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.787",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4547",
  "video-embed": "/video-embed/static-1.35807",
  "content-icons-ui": "/content-icons-ui/static-1.2229",
  "social-insights-client-types": "/social-insights-client-types/static-1.22151",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4823",
  "integrations-lib": "/integrations-lib/static-1.16185",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4269",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14849",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7616",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35793",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3603",
  "highcharts": "/highcharts/static-8.104",
  "trellis-story-utils": "/trellis-story-utils/static-1.4526",
  "storybook-react": "/storybook-react/static-1.33",
  "hub-http-contrib": "/hub-http-contrib/static-1.3053",
  "tinymce-data": "/tinymce-data/static-1.40490",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5221",
  "codemirror": "/codemirror/static-5.95",
  "layout-dnd-components": "/layout-dnd-components/static-1.12468",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11443",
  "react-codemirror": "/react-codemirror/static-1.10637",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15322",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9065",
  "outpost": "/outpost/static-1.4192",
  "flux-actions": "/flux-actions/static-1.338",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13600",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5611",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7792",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10376",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.505",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68478",
  "layout-data-lib": "/layout-data-lib/static-1.9768",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3023",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.277",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.395",
  "slack-ui-library": "/slack-ui-library/static-1.10403",
  "advanced-menus-core": "/advanced-menus-core/static-1.15145",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12084",
  "ExportDialog": "/ExportDialog/static-6.10399",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34082",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15144",
  "simple-menus-lib": "/simple-menus-lib/static-1.16661"
}
};
